<template>
  <div class="content-container" :style="styles" :class="{'white-text': white_text}">
    <div class="title-container">
      <h2 class="h1 title">
        {{ title }}
      </h2>
    </div>
    <div class="content">
      <div class="copy" v-html="body"></div>
    </div>
    <div class="buttons" v-if="button_list">
      <button-link v-for="(button, index) in button_list" :key="index" v-bind="button"/>
    </div>
  </div>
</template>

<script>
import ButtonLink from './components/ButtonLink'


export default {
  name: "ContentModule",
  components: {ButtonLink},
  props: {
    body: String,
    button_list: [Boolean, Array],
    content_background_color: String,
    title: String,
    white_text: Boolean,
  },
  computed: {
    styles() {
      return {
        backgroundColor: this.content_background_color
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.content-container {

  &.white-text * {
    color: #fff;
  }
}

</style>
